import Vue from 'vue';
import Router from 'vue-router';
import Layout from './layout/Index.vue';

Vue.use(Router);

/**
 * 懒加载引入组件
 * @param {String} name 文件夹名称
 * @param {String} component 视图组件名称
 */
const getComponent = component => () => import(`./views/${component}.vue`);

export default new Router({
  mode: 'history',
  base: 'Lives.html',
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: '/home',
      children: [
        {
          path: '/home',
          name: 'home',
          component: getComponent('index'),
          meta: {
            title: '首页',
            keepAlive: true,
            refresh: null
          }
        },
        {
          // path: '/detail/:id/:liveId/:code',
          path: '/detail/:liveId/:streamCode/:schoolName',
          name: 'detail',
          component: getComponent('detailCode'),
          meta: {
            title: '详情'
          }
        },
        {
          path: '/share',
          name: 'share',
          component: getComponent('share'),
          meta: {
            title: '直播分享'
          }
        },
        {
          path: '/shareCode',
          name: 'shareCode',
          component: getComponent('shareCode'),
          meta: {
            title: '直播分享'
          }
        },
        {
          path: '/add',
          name: 'addLive',
          component: getComponent('addLive'),
          meta: {
            title: '添加直播'
          }
        },
        {
          path: '/addToCode',
          name: 'addLiveToCode',
          component: getComponent('addLiveToCode'),
          meta: {
            title: '添加直播'
          }
        },
        {
          path: '/indexToCode',
          name: 'indexToCode',
          component: getComponent('indexToCode'),
          meta: {
            title: '直播列表',
            keepAlive: true,
            refresh: null
          }
        },
        {
          path: '/live/:id/:liveId/:code/:mobile',
          name: 'live',
          component: getComponent('liveShare'),
          meta: {
            title: '直播详情'
          }
        },
        {
          path: '/liveShare/:liveId/:schoolName/:streamStatus/:mobile',
          name: 'liveShare',
          component: getComponent('liveShareCode'),
          meta: {
            title: '直播详情'
          }
        },
        {
          path: '/video/:id/:rId/:name',
          name: 'video',
          component: getComponent('videoShare'),
          meta: {
            title: '视频详情'
          }
        },
        {
          path: '/register',
          name: 'register',
          component: getComponent('register'),
          meta: {
            title: '用户注册'
          }
        }
      ]
    }
  ]
});
